(function () {
  var layout = document.querySelector(".rfmax_blog-post-layout");
  if (!layout) return;

  var main = layout.querySelector(".rfmax_blog-post-layout-main");
  var sidebar = layout.querySelector(".rfmax_blog-listing-sidebar");
  if (!main || !sidebar) return;

  var lastMainH = 0;
  var lastSideH = 0;
  var lastViewW = 0;
  var lastViewH = 0;

  function isSideBySide() {
    return (
      main.getBoundingClientRect().left !== sidebar.getBoundingClientRect().left
    );
  }

  function reset() {
    main.style.cssText = "";
    sidebar.style.cssText = "";
  }

  function apply() {
    if (!isSideBySide()) {
      reset();
      return;
    }

    var viewH = window.innerHeight;
    var mainH = main.scrollHeight;
    var sideH = sidebar.scrollHeight;

    // No sticky needed if equal height
    if (Math.abs(mainH - sideH) < 10) {
      reset();
      return;
    }

    var shorter, shorterH;

    if (mainH < sideH) {
      shorter = main;
      shorterH = mainH;
    } else {
      shorter = sidebar;
      shorterH = sideH;
    }

    // Reset both
    main.style.cssText = "";
    sidebar.style.cssText = "";

    var stickyTop;

    if (shorterH <= viewH) {
      stickyTop = viewH - shorterH;
    } else {
      stickyTop = -(shorterH - viewH);
    }

    shorter.style.position = "sticky";
    shorter.style.top = stickyTop + "px";
    shorter.style.alignSelf = "flex-start";
  }

  function measureIfChanged() {
    var mainH = main.scrollHeight;
    var sideH = sidebar.scrollHeight;
    var viewW = window.innerWidth;
    var viewH = window.innerHeight;

    if (
      mainH === lastMainH &&
      sideH === lastSideH &&
      viewW === lastViewW &&
      viewH === lastViewH
    )
      return;

    lastMainH = mainH;
    lastSideH = sideH;
    lastViewW = viewW;
    lastViewH = viewH;
    apply();
  }

  // Resize
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureIfChanged, 150);
  });

  // Initial
  apply();
  lastMainH = main.scrollHeight;
  lastSideH = sidebar.scrollHeight;
  lastViewW = window.innerWidth;
  lastViewH = window.innerHeight;

  // Re-check for async content
  var checks = 0;
  var interval = setInterval(function () {
    measureIfChanged();
    checks++;
    if (checks > 20) clearInterval(interval);
  }, 400);

  window.addEventListener("load", function () {
    measureIfChanged();
  });
})();
